import { Component } from '@angular/core';
import {
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { CustomerService } from '../../../customer/services/customer.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ErrorService } from '../../../../core/services/error.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-lookup-customer-id',
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslocoPipe
  ],
  templateUrl: './lookup-customer-id.dialog.html',
  styleUrl: './lookup-customer-id.dialog.scss'
})
export class LookupCustomerIdDialog {
  customerKeyFormControl: FormControl = new FormControl('');
  constructor(private dialogRef: MatDialogRef<LookupCustomerIdDialog>, private customerService: CustomerService, private errorService: ErrorService, private translocoService: TranslocoService) {
  }

  close(): void {
    this.dialogRef.close();
  }

  lookupCustomerId(): void {
    let customerKey = this.customerKeyFormControl.value;

    this.customerService.lookupCustomerId(customerKey).subscribe({
      next: (customerParameter) => {
        this.dialogRef.close(customerParameter.customerId);
      },
      error: (error) => {
        this.errorService.handleError(error, this.translocoService.translate('error.title.lookup_customer_id'));
      }
    });
  }
}
